export function iterable(object) {
  let array = object

  if (!object) {
    array = []
  }

  if (object instanceof HTMLElement) {
    array = [object]
  }

  if (object instanceof NodeList || object instanceof HTMLCollection) {
    array = Array.from(object)
  }

  return array
}
